import type { FC } from "react";

import type { Variants } from "@/src/common/links/useSvgStyle";
import { useSvgVariant } from "@/src/common/links/useSvgStyle";
import type { PropsWithStyleX } from "@stylex/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

const styles = stylex.create({
    icon: {
        height: "21px",
        width: "25px",
    },
});

export const TwitterIcon: FC<PropsWithStyleX & { variant: Variants }> = ({ styleX, variant }) => {
    const { fill } = useSvgVariant(variant);

    return (
        <svg
            {...stylex.props(styles.icon, styleX)}
            viewBox="0 0 24 24"
            aria-hidden="true"
            className="r-4qtqp9 r-yyyyoo r-dnmrzs r-bnwqim r-lrvibr r-m6rgpd r-lrsllp r-1nao33i r-16y2uox r-8kz0gk"
        >
            <g>
                <path
                    {...stylex.props(fill)}
                    d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
                />
            </g>
        </svg>
    );
};
